import notification from "@/services/notify";
export default {
    notification
}